import AuthService from "./auth.class.js";
import { isOpenedFromApp } from "./app.helpers.js";

(async function () {
  if (!isOpenedFromApp() || !AuthService.getToken()) {
    return;
  }

  // Get user
  let user;

  try {
    const sessionUser = sessionStorage.getItem("user");

    user = sessionUser ? JSON.parse(sessionUser) : await AuthService.user();

    if (!sessionUser) {
      sessionStorage.setItem("user", JSON.stringify(user));
    }
  } catch (error) {
    Sentry.captureException(error, {
      extra: { message: "Failed to get user" },
    });

    return;
  }

  // Get cart forms
  const cartForm = document.getElementById("cart-form");
  const cartDrawerForm = document.getElementById("cart-drawer-form");

  // Generate new action URL
  const checkoutUrl = new URL(
    cartForm?.action || cartDrawerForm?.action || location.origin + "/cart"
  );

  // Set checkout parameters. See https://shopify.dev/docs/apps/build/checkout/create-cart-permalinks#supported-checkout-parameters
  if (user.email) {
    checkoutUrl.searchParams.set("checkout[email]", user.email);
  }

  if (user.first_name) {
    checkoutUrl.searchParams.set(
      "checkout[shipping_address][first_name]",
      user.first_name
    );
  }

  if (user.last_name) {
    checkoutUrl.searchParams.set(
      "checkout[shipping_address][last_name]",
      user.last_name
    );
  }

  if (user.street) {
    checkoutUrl.searchParams.set(
      "checkout[shipping_address][address1]",
      user.street
    );
  }

  if (user.city) {
    checkoutUrl.searchParams.set("checkout[shipping_address][city]", user.city);
  }

  if (user.zip) {
    checkoutUrl.searchParams.set("checkout[shipping_address][zip]", user.zip);
  }

  // Set action attribute to cart forms
  cartForm?.setAttribute("action", checkoutUrl.toString());
  cartDrawerForm?.setAttribute("action", checkoutUrl.toString());
})();
